import { useMemo, useState } from 'react';
import { inventoryValue } from '@/entities/item/helpers/inventory-value';
import { useItems } from '@/entities/item/hooks/use-items';
import type { Category } from '@/entities/shared/category/category';
import { rankSuggestions } from '@/shared/lib/text/rank-suggestions';
import { filterItems } from '../helpers/filter-items';
import type { InventoryFilter, InventorySort } from '../schemas/inventory-filter';

export function useInventory() {
  const items = useItems();
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState<Category | ''>('');
  const [location, setLocation] = useState('');
  const [filter, setFilter] = useState<InventoryFilter>('all');
  const [sort, setSort] = useState<InventorySort>('due');
  const locations = useMemo(() => rankSuggestions(items ?? [], (item) => item.data.location), [items]);
  const shown = useMemo(
    () => (items ? filterItems(items, { query, category, location, filter, sort }) : undefined),
    [items, query, category, location, filter, sort],
  );
  return {
    items,
    shown,
    locations,
    total: items ? inventoryValue(items) : 0,
    criteria: { query, category, location, filter, sort },
    setQuery,
    setCategory,
    setLocation,
    setFilter,
    setSort,
  };
}
